




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ApiRequest, MileageLimitRequest, ServiceRequestModel } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, maxLength, minValue } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import DatePicker from '../../components/DatePicker.vue';
import { HealthcareProvider, OrgLocation, Patient, RxProvider, Attorney } from '../../types/entity';
import { ObjectFactory } from '../../config/objectFactory';
import AddLocationModal from '../modal/AddLocationModal.vue';
import AddPatientModal from '../modal/AddPatientModal.vue';
import AddHealthcareProviderModal from '../modal/AddHealthCareProviderModal.vue';
import { UploadFileResponse } from '@/types/response';
import { MemberProfile } from '@/types/response';
import { ModelSelect } from 'vue-search-select';
import { DateUtils } from '@/util/dateUtils';
import { CommonUtils } from '@/util/commonUtils';
import VSelect from 'vue-select';
declare var google: any;
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import AddRxProviderModal from '../modal/AddRxProviderModal.vue';
import AddAttorneyModal from '../modal/AddAttorneyModal.vue';
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
// tslint:disable-next-line: no-var-requires
const validationErrorMessages = require('../../config/validationErrorMessages.json');
@Component({
    mixins: [validationMixin],
    props: {
        serviceRequest: Object,
    },
    components: {
        DatePicker,
        AddLocationModal,
        ModelSelect,
        AddHealthcareProviderModal,
        AddPatientModal,
        VSelect,
        AddRxProviderModal,
        AddAttorneyModal,
    },
    watch: {
        'serviceRequest': {
            handler(newValue, oldValue) {
                if (this.$v.$invalid) {
                    this.$props.serviceRequest.stops.isStop3Valid = false;
                } else {
                    this.$props.serviceRequest.stops.isStop3Valid = true;
                }
            },
            deep: true,
            immediate: true,
        },

        'serviceRequest.pickupAddress.fullAddress'(newVal, oldVal) {
            if (
                newVal !== oldVal &&
                this.$props.serviceRequest.service.type === 'Transportation' &&
                this.$props.serviceRequest.pickupAddress.fullAddress &&
                this.$props.serviceRequest.dropoffAddress.fullAddress
            ) {
                (this as AddressBilling).checkMileage();
            }
        },

        'serviceRequest.dropoffAddress.fullAddress'(newVal, oldVal) {
            if (
                newVal !== oldVal &&
                this.$props.serviceRequest.service.type === 'Transportation' &&
                this.$props.serviceRequest.pickupAddress.fullAddress &&
                this.$props.serviceRequest.dropoffAddress.fullAddress
            ) {
                (this as AddressBilling).checkMileage();
            }
        },
    },
    computed: {
        lastMinuteMessage() {
            if (!this.$props.serviceRequest.transportation.rideshareService) {
                const addressBilling = this as AddressBilling;
                const lastMinuteMessage = CommonUtils.translateMessageCode('MSG_LAST_MINUTE_REQUEST');
                if (!this.$props.serviceRequest.multipleAppointment && addressBilling.isLastMinuteRequest) {
                    return lastMinuteMessage;
                }
            }
        },
        lastMinuteMessageForMultiple() {
            if (!this.$props.serviceRequest.transportation.rideshareService) {
                const addressBilling = this as AddressBilling;
                const lastMinuteMessage = CommonUtils.translateMessageCode('MSG_LAST_MINUTE_REQUEST');
                if (this.$props.serviceRequest.multipleAppointment && addressBilling.isLastMinuteRequest) {
                    return lastMinuteMessage;
                }
            }
        },
        healthcareProviderOptions() {
            const billingLocationProviders: any[] = [];
            const healthcareProviders: any[] = [];
            const addressBilling = this as AddressBilling;
            addressBilling.healthcareProviders.forEach((healthcareProvider) => {
                if (healthcareProvider.status === 'ACTIVE') {
                    const providersOption = {
                        value: healthcareProvider.fullname,
                        text: healthcareProvider.fullname,
                    };
                    if (this.$props.serviceRequest.billingLocationId && healthcareProvider.billingLocationId &&
                        this.$props.serviceRequest.billingLocationId === healthcareProvider.billingLocationId) {
                        billingLocationProviders.push(providersOption);
                    } else {
                        healthcareProviders.push(providersOption);
                    }

                }
            });
            const finalProviders = billingLocationProviders.length ? billingLocationProviders : healthcareProviders;
            return finalProviders;
        },
    },
    data() {
        return {
            member: ObjectFactory.getCacheService().getMemberInfo(),
            pickupAddress: {
                address1: '',
                address2: '',
                state: '',
                city: '',
                county: '',
                landmark: '',
                zip: '',
                pickupInstruction: '',
                pickupInstructionImageUrl: '',
            },
            dropoffAddress: {
                address1: '',
                address2: '',
                state: '',
                city: '',
                county: '',
                landmark: '',
                zip: '',
                dropOffInstruction: '',
                dropoffInstructionImageUrl: '',
            },
            rxStop: {
                rxStopName: '',
                rxAddress: {
                    fullAddress: '',
                    state: '',
                    city: '',
                    county: '',
                    zip: '',
                },
            },
            rxAdditionalNotes: '',
            options: [],
            preferredProviders: [],
            patientOptions: [],
            attorneyOptions: [],
            item: {
                value: '',
                text: '',
            },
            isRxStopEnabled: '',
            pickupInstructionImageUploading: false,
            dropoffInstructionImageUploading: false,
            pickupImgUploadedByCustomer: false,
            dropoffImgUploadedByCustomer: false,
            rxProvidersOptions: [],
            additionalContacts: [],
            isLienCustomerEnabled: true,
            isAdmin: false,
            validationErrorMessages: [],
            showRequiredFieldMessage: false,
        };
    },
    validations() {
        const validations = {
            serviceRequest: {
                facility: {
                    name: {
                        required,
                    },
                    email: {
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(10),
                        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                        notRepeated: (phone: any) => MedTransGoConstants.PHONE_NOT_REPEATED_REGEX.test(phone.replace(/\D/g, '')),
                    },
                    address: {
                        fullAddress: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                },
                coordinator: {
                    name: {
                        required,
                        regex: (fullName: any) => /^[ a-zA-Z ]+$/.test(fullName),
                    },
                    email: {
                        required,
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(10),
                        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                    },
                },
                patient: {
                    firstName: {
                        required,
                        regex: (firstName: any) => /^[ a-zA-Z ]+$/.test(firstName),
                    },
                    lastName: {
                        required,
                        regex: (lastName: any) => /^[ a-zA-Z ]+$/.test(lastName),
                    },
                    email: {
                        required,
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(10),
                        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                        notRepeated: (phone: any) => MedTransGoConstants.PHONE_NOT_REPEATED_REGEX.test(phone.replace(/\D/g, '')),
                    },
                    address: {
                        fullAddress: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                    birthdate: {
                        required,
                    },
                },
                pickupAddress: {
                    fullAddress: {
                        required,
                    },
                    state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    zip: {
                        required,
                    },
                    pickupInstruction: {
                         maxLength: maxLength(100),
                    },
                    flightsOfStairs: {
                        required,
                        minValue: minValue(0),
                    },
                },
                dropoffAddress: {
                    fullAddress: {
                        required,
                    },
                    state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    zip: {
                        required,
                    },
                    dropOffInstruction: {
                      maxLength: maxLength(100),
                    },
                    flightsOfStairs: {
                        required,
                        minValue: minValue(0),
                    },
                },
                billingLocationId: {
                    required,
                },
                transportation: {
                    attorneyName: {
                        required,
                        regex: (attorneyName: any) => /^[a-zA-Z ]+$/.test(attorneyName),
                    },
                    attorneyEmail: {
                        required,
                        email,
                    },
                    attorneyFirmName: {
                        required,
                    },
                    attorneyPhoneNo: {
                        required,
                    },
                    hasRxStop: {
                        type: Boolean,
                        required,
                    },
                    rxStop: {
                        rxStopName: {
                            required,
                        },
                        rxAddress: {
                            fullAddress: {
                                required,
                            },
                            state: {
                                required,
                            },
                            city: {
                                required,
                            },
                            zip: {
                                required,
                            },
                        },
                    },
                },
                delivery: {
                    confirmationMode: {
                        required,
                    },
                    additionalIdentifiers: {
                        minLength: minLength(1),
                    },
                },
                cmr: {
                    patientSecPhone: {
                        regex: (patientSecPhone: any) => MedTransGoConstants.PHONE_REGX.test(patientSecPhone),
                    },
                },
                appointments: {
                    required,
                    $each: {
                        date: {
                            required,
                        },
                        time: {
                            required,
                        },
                    },
                },
                preferredProviderRequired: {
                    required,
                },
                preferredProvider: {
                    required,
                },
                additionalContacts: {
                    $each: {
                        contactName: {
                            required,
                        },
                        relationshipToPatient: {
                            required,
                        },
                        isSMS: {
                            checkboxChecked: (value: any, parentVm: any) => {
                                return parentVm.isEmail || parentVm.isSMS;
                            },
                        },
                        isEmail: {
                            checkboxChecked: (value: any, parentVm: any) => {
                                return parentVm.isEmail || parentVm.isSMS;
                            },
                        },
                        email: {
                            require: (value: any, parentVm: any) => {
                                return parentVm.isEmail ? !!value : true;
                            },
                            email,
                        },
                        phone: {
                            require: (value: any, parentVm: any) => {
                                return parentVm.isSMS ? !!value : true;
                            },
                            minLength: minLength(12),
                        },
                    },
                },
            },
        };
        const serviceRequest = this.$props.serviceRequest;
        if (serviceRequest.service.type === 'HomeHealthCare') {
            delete validations.serviceRequest.dropoffAddress;
            delete validations.serviceRequest.pickupAddress;
            delete validations.serviceRequest.facility.email;
        }
        if (serviceRequest.service.type === 'Interpretation') {
            delete validations.serviceRequest.patient.address;
            delete validations.serviceRequest.dropoffAddress;
            delete validations.serviceRequest.pickupAddress;
            delete validations.serviceRequest.facility.email;
        }
        if (serviceRequest.service.type !== 'Interpretation') {
            delete validations.serviceRequest.coordinator;
        }
        if (serviceRequest.service.type === 'Telemedicine') {
            delete validations.serviceRequest.dropoffAddress;
            delete validations.serviceRequest.pickupAddress;
            delete validations.serviceRequest.patient;
            delete validations.serviceRequest.facility;
        }
        if (serviceRequest.service.type === 'Delivery') {
            delete validations.serviceRequest.facility;
            delete validations.serviceRequest.dropoffAddress.flightsOfStairs;
            delete validations.serviceRequest.pickupAddress.flightsOfStairs;
        }
        if (serviceRequest.service.type !== 'Delivery') {
            delete validations.serviceRequest.delivery.confirmationMode;
        }
        if (serviceRequest.service.type === 'Delivery' && serviceRequest.delivery.isCmr) {
            delete validations.serviceRequest.delivery.confirmationMode;
        }
        if (serviceRequest.service.type === 'Transportation') {
            delete validations.serviceRequest.facility.email;
        }
        if (serviceRequest.service.type !== 'Transportation' ||
            !this.$data.isLienCustomerEnabled ||
            (this.$data.member.memberType !== 'ORG_LIEN_CUSTOMER' && !this.$data.isAdmin)) {
            delete validations.serviceRequest.transportation.attorneyName;
            delete validations.serviceRequest.transportation.attorneyEmail;
            delete validations.serviceRequest.transportation.attorneyPhoneNo;
            delete validations.serviceRequest.transportation.attorneyFirmName;
        }
        if (serviceRequest.service.type === 'TransInterpreter'
            && serviceRequest.interpretation.serviceType === 'In-Person') {
            delete validations.serviceRequest.facility.email;
        }
        if (!this.$props.serviceRequest.delivery.isCmr) {
            delete validations.serviceRequest.cmr;
        }
        if (this.$props.serviceRequest.delivery && this.$props.serviceRequest.delivery.isCmr &&
            this.$props.serviceRequest.cmr.patientSecPhone === undefined) {
            delete validations.serviceRequest.cmr.patientSecPhone.regex;
        }
        if (CommonUtils.isEmpty(this.$data.preferredProviders)) {
            delete validations.serviceRequest.preferredProviderRequired;
            delete validations.serviceRequest.preferredProvider;
        } else if (serviceRequest.preferredProviderRequired !== null) {
            if (!serviceRequest.preferredProviderRequired) {
                delete validations.serviceRequest.preferredProvider;
            }
        }
        if (!this.$props.serviceRequest.transportation.hasRxStop) {
            delete validations.serviceRequest.transportation.hasRxStop;
            delete validations.serviceRequest.transportation.rxStop;
        }
        if (!this.$data.isRxStopEnabled) {
            delete validations.serviceRequest.transportation.hasRxStop;
            delete validations.serviceRequest.transportation.rxStop;
        }
        if (!this.$data.isLienCustomerEnabled && this.$data.member.memberType !== 'ORG_LIEN_CUSTOMER'
            && serviceRequest.service.type === 'Transportation') {
            delete validations.serviceRequest.patient.email;
        }
        if (!this.$data.isLienCustomerEnabled && serviceRequest.service.type !== 'Telemedicine') {
            delete validations.serviceRequest.patient.birthdate;
        } else if (serviceRequest.service.type !== 'Transportation' && serviceRequest.service.type !== 'Telemedicine') {
            delete validations.serviceRequest.patient.birthdate;
        }
        if (this.$data.isAdmin && !this.$data.isLienCustomerEnabled && validations.serviceRequest.patient
            && validations.serviceRequest.patient.email) {
            delete validations.serviceRequest.patient.email;
        }
        if (this.$data.isAdmin && !this.$data.isLienCustomerEnabled && validations.serviceRequest.patient
            && validations.serviceRequest.patient.birthdate) {
            delete validations.serviceRequest.patient.birthdate;
        }
        if (this.$data.isLienCustomerEnabled) {
            delete validations.serviceRequest.billingLocationId;
        }
        this.$data.validationErrorMessages = [];
        const isEmpty = (value: any) => {
            return value === undefined || value === null || value === '';
        };
        const checkFields = (data: any, validationRules: any, path = '') => {
            const addressMessagesAdded: any = {};
            Object.keys(validationRules).forEach((fieldName) => {
                const fieldValidation = validationRules[fieldName];
                const fieldPath = path ? `${path}.${fieldName}` : fieldName;
                if (fieldName === '$each') {
                    if (fieldPath.includes('appointments')) {
                        const appointments = getField(serviceRequest, 'appointments');
                        if (appointments && Array.isArray(appointments)) {
                            appointments.forEach((appointment: any, index: number) => {
                                Object.keys(fieldValidation).forEach((subFieldName) => {
                                    const subFieldValidation = fieldValidation[subFieldName];
                                    let subFieldPath = `${fieldPath}.${subFieldName}`;
                                    if (subFieldValidation.required) {
                                        const fieldValueInAppointment = getField(appointment, subFieldName);
                                        if (isEmpty(fieldValueInAppointment)) {
                                            subFieldPath = subFieldPath.replace(/\$each\./g, '');
                                            const keys = subFieldPath.split('.');
                                            let value = validationErrorMessages;
                                            for (const key of keys) {
                                                try {
                                                    value = value[key];
                                                } catch (error) {
                                                    console.log('error while getting field');
                                                }
                                            }
                                            if (value) {
                                                this.$data.validationErrorMessages.push(value);
                                            }
                                        }
                                    }
                                });
                            });
                        }
                    } else if (fieldPath.includes('additionalContacts')) {
                        const additionalContacts = getField(serviceRequest, 'additionalContacts');
                        if (additionalContacts && Array.isArray(additionalContacts)) {
                            additionalContacts.forEach((additionalContact: any, index: number) => {
                                const { contactName, relationshipToPatient, isSMS, isEmail, phone }
                                    = additionalContact;
                                const contactEmail = additionalContact.email;
                                if (!contactName) {
                                    this.$data.validationErrorMessages.push('Contact name is required');
                                }
                                if (!relationshipToPatient) {
                                    this.$data.validationErrorMessages.push('Please enter contact relationship with patient');
                                }
                                if (isSMS || isEmail) {
                                    if (!contactEmail && isEmail) {
                                        this.$data.validationErrorMessages.push('Please enter an email for additional contact');
                                    }
                                    if (!phone && isSMS) {
                                        this.$data.validationErrorMessages.push('Please enter an phone number for additional contact');
                                    }
                                } else {
                                    this.$data.validationErrorMessages.push('Please select at least one option for communication (SMS or Email) for contact');
                                }
                            });
                        }
                    }
                } else {
                    if (fieldValidation.required) {
                        const fieldValueInServiceRequest = getField(serviceRequest, fieldPath);
                        if (isEmpty(fieldValueInServiceRequest)) {
                            let message = '';
                            if (fieldPath.includes('address')) {
                                let addressType = '';
                                if (fieldPath.includes('pickupAddress')) {
                                    addressType = 'pickup';
                                } else if (fieldPath.includes('dropoffAddress')) {
                                    addressType = 'dropoff';
                                } else if (fieldPath.includes('patient')) {
                                    addressType = 'patient';
                                } else if (fieldPath.includes('facility')) {
                                    addressType = 'facility';
                                } else if (fieldPath.includes('rxStop')) {
                                    addressType = 'rx stop';
                                }
                                if (addressType && !addressMessagesAdded[addressType]) {
                                    addressMessagesAdded[addressType] = true;
                                    const keys = fieldPath.split('.');
                                    let value = validationErrorMessages;
                                    for (const key of keys) {
                                        value = value[key];
                                    }
                                    if (value) {
                                        message = value;
                                    }
                                }
                            } else {
                                const keys = fieldPath.split('.');
                                let value = validationErrorMessages;
                                for (const key of keys) {
                                    value = value[key];
                                }
                                if (value) {
                                    message = value;
                                }
                            }
                            if (message) {
                                this.$data.validationErrorMessages.push(message);
                            }
                        }
                    }
                    if (typeof fieldValidation === 'object') {
                        checkFields(data, fieldValidation, fieldPath);
                    }
                }
            });
        };

        const getField = (data: any, fieldPath: any) => {
            const pathArray = fieldPath.split('.');
            let value = data;
            for (const pathItem of pathArray) {
                if (!value) {
                    return undefined;
                }
                value = value[pathItem];
                if (value === undefined) {
                    break;
                }
            }
            return value;
        };
        checkFields(this.$data, validations.serviceRequest);
        return validations;
    },
})
export default class AddressBilling extends Vue {

    private facilityGoogleAddress: any;
    private patientGoogleAddress: any;
    private pickupGoogleAddress: any;
    private dropoffGoogleAddress: any;
    private rxStopGoogleAddress: any;
    private showAddHealthcareProviderForm = false;
    private showAddPatientForm = false;
    private isInvalidValidTime = false;
    private locations: OrgLocation[] = [];
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private showAddLocationForm = false;
    private isLastMinuteRequest = false;
    private healthcareProviders: HealthcareProvider[] = [];
    private patient: Patient[] = [];
    private questionCounter = 0;
    private maxDate = new Date();
    private TimeZones = TimeZones;
    private isPatientEmailRequired = true;
    private showAddRxProviderForm = false;
    private rxProviders: RxProvider[] = [];
    private showAdditionalContacts = false;
    private selectedTimezone = {};
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private showAddAttorneyForm = false;
    private mileageLimit: any = '';
    private isNextDisabled = false;

    public async mounted() {
        this.TimeZones.forEach((continent: any) => {
            continent.timezones.forEach((timezone: any) => {
                timezone.value = timezone.utc[0];
            });
        });
        this.$data.isAdmin = this.sessionInfo.scopes.includes('admin');
        const organizationResponse = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organizationResponse.success && organizationResponse.data) {
            if (organizationResponse.data.rxStopEnabled) {
                this.$data.isRxStopEnabled = true;
            } else {
                this.$data.isRxStopEnabled = false;
            }
            if (!organizationResponse.data.lienCustomerEnabled) {
                this.$data.isLienCustomerEnabled = false;
            }
        }
        const element = document.querySelector('.reqStepMain') as Element;
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.service.type === 'Transportation' && !serviceRequest.patient.birthdate) {
            this.updateBirthdate('');
        }
        if (serviceRequest.transportation && !serviceRequest.transportation.driverGenderPreference) {
            serviceRequest.transportation.driverGenderPreference = 'No Preference';
        }
        if (serviceRequest.patient.preferredLanguage === '') {
            serviceRequest.patient.preferredLanguage = 'English';
        }
        if (!serviceRequest.stops.isStop2Valid) {
            if (serviceRequest.service.selectedType === 'Telemedicine') {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_MEETING_DETAILS });
            } else if (serviceRequest.service.selectedType === 'Delivery') {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_PICKUP_DETAILS });
            } else if (serviceRequest.service.selectedType === 'HomeHealthCare') {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_HOME_HEALTHCARE_DETAILS });
            } else {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_VEHICLE_LANGUAGE });
            }
            return;
        }
        if (this.memberProfile.memberType !== 'ORG_LIEN_CUSTOMER' && serviceRequest.service.type === 'Transportation') {
            this.isPatientEmailRequired = this.$data.isLienCustomerEnabled && this.$data.isAdmin;
        }
        if (serviceRequest.service.selectedType !== 'Telemedicine') {
            this.patientGoogleAddress = new google.maps.places.Autocomplete(this.$refs.patientAddress,
                { types: ['geocode'] });

            if (serviceRequest.service.selectedType !== 'Delivery') {
                this.facilityGoogleAddress = new google.maps.places.Autocomplete(this.$refs.facilityAddress,
                    { types: ['geocode'] });
                this.facilityGoogleAddress.addListener('place_changed', async () => {
                    this.$props.serviceRequest.facility.address =
                        MapUtils.parseGoogleAddress(this.facilityGoogleAddress);
                    const address = this.$props.serviceRequest.facility.address;
                    this.$props.serviceRequest.appointments[0].timezone = address.timezone;
                    this.setSelectedTimezone(address.timezone);
                    this.copyDropoffAddresses();
                    this.copyPickupAddresses();
                });
            }
            this.patientGoogleAddress.addListener('place_changed', async () => {
                this.$props.serviceRequest.patient.address = MapUtils.parseGoogleAddress(this.patientGoogleAddress);
                if (serviceRequest.service.selectedType !== 'Delivery') {
                    const address = this.$props.serviceRequest.patient.address;
                    this.$props.serviceRequest.patient.address.timezone = address.timezone;
                    this.copyPickupAddresses();
                    this.copyDropoffAddresses();
                }
            });
        }
        if (serviceRequest.service.type !== 'Interpretation') {
            this.pickupGoogleAddress = new google.maps.places.Autocomplete(this.$refs.pickupGoogleAddress,
                { types: ['geocode'] });
            this.pickupGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.pickupAddress = MapUtils.parseGoogleAddress(this.pickupGoogleAddress);
            });
            this.dropoffGoogleAddress = new google.maps.places.Autocomplete(this.$refs.dropoffGoogleAddress,
                { types: ['geocode'] });
            this.dropoffGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.dropoffAddress = MapUtils.parseGoogleAddress(this.dropoffGoogleAddress);
            });
        }
        if (serviceRequest.service.type === 'Interpretation' && serviceRequest.interpretation &&
            serviceRequest.interpretation.isImmediateInterpretation) {
            serviceRequest.appointments[0].date = DateUtils.formatDate(new Date(), 'YYYY-MM-DD');
            serviceRequest.appointments[0].time = DateUtils.formatDate(new Date().getTime()
                + DateUtils.convertMinutesToMillis(5), 'HH:mm');
            this.questionCounter = 1;
        } else {
            this.questionCounter = 0;
        }
        if (serviceRequest.service.type === 'Transportation' && serviceRequest.transportation &&
            serviceRequest.transportation.isImmediateTransportation) {
            serviceRequest.appointments[0].date = DateUtils.formatDate(new Date(), 'YYYY-MM-DD');
            serviceRequest.appointments[0].time = DateUtils.formatDate(new Date().getTime()
                + DateUtils.convertMinutesToMillis(1), 'HH:mm');
            this.questionCounter = 1;
        } else {
            this.questionCounter = 0;
        }
        this.getOrganizationLocations();
        this.getHealthcareProviders();
        this.getPatientList();
        this.maxDate.setFullYear(this.maxDate.getFullYear());
        if (serviceRequest.service.type === 'Transportation' || serviceRequest.service.type === 'Interpretation') {
            this.$data.preferredProviders = this.$store.state.preferredProviders;
            if (CommonUtils.isEmpty(this.$data.preferredProviders)) {
                serviceRequest.preferredProviderRequired = null as any;
                serviceRequest.preferredProvider = '' as any;
            }
        }
        if (this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageUrl) {
            this.$data.dropoffAddress.dropoffInstructionImageUrl =
                this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageUrl;
        }
        if (this.$props.serviceRequest.pickupAddress) {
            this.$data.pickupAddress.pickupInstructionImageUrl =
            this.$props.serviceRequest.pickupAddress.pickupInstructionImageUrl;
        }
        if (serviceRequest.service.type === 'Interpretation' && serviceRequest.interpretation) {
            if ( !serviceRequest.interpretation.estimatedTime.hours) {
                 serviceRequest.interpretation.estimatedTime.hours = 0;
            }
            if (!serviceRequest.interpretation.estimatedTime.minutes) {
                 serviceRequest.interpretation.estimatedTime.minutes = 0;
            }
        }
        if (serviceRequest.service.type === 'Transportation' && serviceRequest.transportation) {
            const isRoundPickup = serviceRequest.roundTrip && serviceRequest.transportation.timescope &&
            serviceRequest.transportation.timescope === 'Pickup';
            if (!serviceRequest.transportation.estimatedVisitTime.hours || isRoundPickup) {
                serviceRequest.transportation.estimatedVisitTime.hours = 0;
            }
            if (!serviceRequest.transportation.estimatedVisitTime.minutes || isRoundPickup) {
                serviceRequest.transportation.estimatedVisitTime.minutes = 0;
            }
        }
        this.getRxProviderList();
        this.setSelectedTimezone(this.$props.serviceRequest.appointments[0].timezone);
        this.getAttorneyList();
        if (this.$props.serviceRequest.hasUserDeclinedMileage === true) {
            this.isNextDisabled = true;
        } else {
            this.isNextDisabled = false;
        }
    }

    private initPatientAddressAutocomplete() {
        if (!this.$refs.patientAddress) {
            return;
        }
        this.patientGoogleAddress = new google.maps.places.Autocomplete(this.$refs.patientAddress,
        { types: ['geocode'] });
        this.patientGoogleAddress.addListener('place_changed', async () => {
                this.$props.serviceRequest.patient.address = MapUtils.parseGoogleAddress(this.patientGoogleAddress);
        });
    }
    private copyPickupAddresses() {
        if (this.$props.serviceRequest.pickupSameAsPatientAddress) {
            this.$props.serviceRequest.pickupAddress = this.$props.serviceRequest.patient.address;
            if (this.$props.serviceRequest.service.selectedType === 'Delivery') {
                this.$props.serviceRequest.dropoffAddress = this.$props.serviceRequest.facility.address;
            }
        } else if (this.$props.serviceRequest.pickupSameAsBussinessAddress) {
            this.$props.serviceRequest.pickupAddress = {
                ...this.$props.serviceRequest.facility.address,
                pickupInstruction: '',
            };
            if (this.$props.serviceRequest.service.selectedType === 'Delivery') {
                this.$props.serviceRequest.dropoffAddress = this.$props.serviceRequest.patient.address;
            }
        } else if (this.$props.serviceRequest.pickupAddress.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress ===
            this.$props.serviceRequest.pickupAddress.fullAddress) {
            this.$props.serviceRequest.pickupAddress = {};
        } else if (this.$props.serviceRequest.pickupAddress.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress ===
            this.$props.serviceRequest.pickupAddress.fullAddress) {
            this.$props.serviceRequest.pickupAddress = {};
        }
        this.copyPickupAndDropOffInstructions();
    }
    private async copyDropoffAddresses() {
        if (this.$props.serviceRequest.dropoffSameAsBussinessAddress) {
            this.$props.serviceRequest.dropoffAddress = {
                ...this.$props.serviceRequest.facility.address,
                dropOffInstruction: '',
            };
        } else if (this.$props.serviceRequest.dropoffSameAsPatientAddress) {
            this.$props.serviceRequest.dropoffAddress = this.$props.serviceRequest.patient.address;
        } else if (this.$props.serviceRequest.dropoffAddress.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress ===
            this.$props.serviceRequest.dropoffAddress.fullAddress) {
            this.$props.serviceRequest.dropoffAddress = {};
        } else if (this.$props.serviceRequest.dropoffAddress.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress ===
            this.$props.serviceRequest.dropoffAddress.fullAddress) {
            this.$props.serviceRequest.dropoffAddress = {};
        }
        this.copyPickupAndDropOffInstructions();
    }
    private async getOrganizationLocations() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.locations || serviceRequest.locations.length <= 0) {
            const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
            if (response.success && response.data) {
                serviceRequest.locations = response.data;
            }
        }
        if (serviceRequest.locations) {
            serviceRequest.locations.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
            this.locations = serviceRequest.locations;
            const managedLocationIds = (this.memberProfile.managedLocations || []).map((ml) => ml.id);
            const locationId = (this.memberProfile.location || {}).id;
            serviceRequest.locations.forEach((location) => {
                if (this.memberProfile.memberType === 'ORG_MEMBER'
                    && (location.id !== locationId && !managedLocationIds.includes(location.id))) {
                    return;
                }
                if (this.memberProfile.memberType === 'ORG_MANAGER' && !managedLocationIds.includes(location.id)) {
                    return;
                }
                const option = {
                    value: location.id,
                    text: location.locationName,
                };
                this.$data.options.push(option);
            });
        }
    }
    private checkIsLastMinute() {
        const currentTime = DateUtils.getCurrentUTCTimeInMillis();
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.service.type === 'Transportation' && serviceRequest.appointments) {
            for (const appointment of serviceRequest.appointments) {
                if (appointment.date && appointment.time) {
                    const dateTime = DateUtils.formatDate(appointment.date + ' ' +
                        appointment.time, 'YYYY-MM-DDTHH:mm:ss.sssZ', appointment.timezone);
                    const appointmentTimestamp = Date.parse(new Date(dateTime).toUTCString());
                    const difference = DateUtils.convertMillisToMinutes(appointmentTimestamp -
                        currentTime);
                    if (difference < 60) {
                        const scope = ObjectFactory.getCacheService().getSessionInfo().scopes;
                        if ((scope.includes('admin') || !serviceRequest.roundTrip) && difference > 0) {
                            this.isInvalidValidTime = false;
                        } else {
                            this.isInvalidValidTime = true;
                        }
                        break;
                    } else {
                        this.isInvalidValidTime = false;
                    }
                } else {
                    this.isInvalidValidTime = false;
                }
            }
            for (const appointment of serviceRequest.appointments) {
                if (appointment.date && appointment.time) {
                    const appointmentTimestamp = DateUtils.convertToUTCInMillis(appointment.date + ' ' +
                        appointment.time, appointment.timezone);
                    const difference = DateUtils.convertMillisToMinutes(appointmentTimestamp -
                        currentTime);
                    if (difference < 240) {
                        this.isLastMinuteRequest = true;
                        break;
                    } else {
                        this.isLastMinuteRequest = false;
                    }
                } else {
                    this.isLastMinuteRequest = false;
                }
            }
        }
    }
    private validateTime(index?: number) {
        const objIndex = index ? index : 0;
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments) {
            let time = new Array();
            time = serviceRequest.appointments[objIndex].time.split(':');
            const hours = parseInt(time[0], 10);
            const minutes = parseInt(time[1], 10);
            if (isNaN(hours) || 0 > hours || hours >= 24 || isNaN(minutes) || 0 > minutes || minutes >= 60) {
                serviceRequest.appointments[objIndex].time = '';
            }
        }
    }
    private validateDate() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.patient.birthdate) {
            const birthdate = new Date(serviceRequest.patient.birthdate);
            const today = new Date();
            if (birthdate > today) {
                serviceRequest.patient.birthdate = '';
            }
        }
    }
    private copyHealthCareAddress(fullname: string) {
        if (this.healthcareProviders) {
            this.healthcareProviders.forEach(async (healthcareProvider) => {
                if (healthcareProvider.fullname === fullname) {
                    if (healthcareProvider.address) {
                        this.$props.serviceRequest.facility.address = healthcareProvider.address;
                        this.$props.serviceRequest.facility.phone = healthcareProvider.phone;
                    } else {
                        this.$props.serviceRequest.facility.address = {
                            city: '',
                            fullAddress: '',
                            state: '',
                            zip: '',
                            timezone: '',
                        };
                    }
                    this.copyDropoffAddresses();
                    if (this.$props.serviceRequest.service.type === 'Interpretation' &&
                        this.$props.serviceRequest.interpretation.serviceType !== 'In-Person') {
                        if (healthcareProvider.email) {
                            this.$props.serviceRequest.facility.email = healthcareProvider.email;
                        } else {
                            this.$props.serviceRequest.facility.email = '';
                        }
                    }
                }
            });
            this.copyPickupAndDropOffInstructions();
        }
    }

    private copyPickupAndDropOffInstructions() {
        if (this.healthcareProviders) {
            this.healthcareProviders.forEach(async (healthcareProvider) => {
                let fullname = '';
                if (this.$props.serviceRequest.facility.name) {
                    fullname = this.$props.serviceRequest.facility.name;
                }
                if (healthcareProvider.fullname === fullname) {
                    if (this.$props.serviceRequest.service.type === 'Transportation'
                        && this.$props.serviceRequest.dropoffSameAsBussinessAddress) {
                            if (healthcareProvider.dropOffInstruction) {
                                this.$props.serviceRequest.dropoffAddress.dropOffInstruction =
                                    healthcareProvider.dropOffInstruction;
                            }
                            if (healthcareProvider.dropoffInstructionImageResourceId) {
                            const getResourceResponse = await
                                this.getResource(healthcareProvider.dropoffInstructionImageResourceId);
                            this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageUrl
                                = getResourceResponse;
                            this.$data.dropoffAddress.dropoffInstructionImageUrl = getResourceResponse;
                            this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageResourceId =
                                healthcareProvider.dropoffInstructionImageResourceId;
                        }
                    } else if (!this.$props.serviceRequest.dropoffSameAsPatientAddress &&
                        this.$props.serviceRequest.service.type === 'Transportation') {
                            if (!this.$data.dropoffImgUploadedByCustomer) {
                                this.$data.dropoffAddress.dropoffInstructionImageUrl = '';
                                this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageResourceId = '';
                                this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageUrl = '';
                            } else {
                                await this.removeImage('dropoff');
                                this.$data.dropoffImgUploadedByCustomer = false;
                            }
                        }
                    if (this.$props.serviceRequest.service.type === 'Transportation' &&
                        this.$props.serviceRequest.pickupSameAsBussinessAddress) {
                            if (healthcareProvider.pickupInstruction) {
                                this.$props.serviceRequest.pickupAddress.pickupInstruction =
                                    healthcareProvider.pickupInstruction;
                            }
                            if (healthcareProvider.pickupInstructionImageResourceId) {
                            const getResourceResponse = await
                                this.getResource(healthcareProvider.pickupInstructionImageResourceId);
                            this.$props.serviceRequest.pickupAddress.pickupInstructionImageUrl
                                = getResourceResponse;
                            this.$data.pickupAddress.pickupInstructionImageUrl = getResourceResponse;
                            this.$props.serviceRequest.pickupAddress.pickupInstructionImageResourceId =
                                healthcareProvider.pickupInstructionImageResourceId;
                        }
                    } else if (this.$props.serviceRequest.service.type === 'Transportation' &&
                            !this.$props.serviceRequest.pickupSameAsPatientAddress) {
                                if (!this.$data.pickupImgUploadedByCustomer) {
                                    this.$data.pickupAddress.pickupInstructionImageUrl = '';
                                    this.$props.serviceRequest.pickupAddress.pickupInstructionImageUrl = '';
                                    this.$props.serviceRequest.pickupAddress.pickupInstructionImageResourceId = '';
                                } else {
                                    await this.removeImage('pickup');
                                    this.$data.pickupImgUploadedByCustomer = false;
                                }
                        }
                }
            });
        }
    }

    private copyPatientAddress(fullname: string) {
        if (this.patient) {
            this.patient.forEach((patient) => {
                if (patient.fullName === fullname) {
                    if (patient.address) {
                        this.$props.serviceRequest.patient.address = patient.address;
                    } else {
                        this.$props.serviceRequest.patient.address = {
                            city: '',
                            fullAddress: '',
                            state: '',
                            zip: '',
                        };
                    }
                    this.copyPickupAddresses();
                    if (patient.email) {
                        this.$props.serviceRequest.patient.email = patient.email;
                    } else {
                        this.$props.serviceRequest.patient.email = '';
                    }
                    if (patient.phone) {
                        this.$props.serviceRequest.patient.phone = patient.phone;
                    } else {
                        this.$props.serviceRequest.patient.phone = '';
                    }
                }
            });
        }
    }
    private preStep() {
        this.$router.go(-1);
    }

    private async onPatientLatLngChanged() {
        const patientAddress = this.$props.serviceRequest.patient.address;
        if (patientAddress.latitude && patientAddress.longitude) {
            this.$props.serviceRequest.patient.address = await MapUtils.getAddressByCoordinates(patientAddress.latitude,
                patientAddress.longitude);
            if (this.$props.serviceRequest.service.selectedType !== 'Delivery') {
                const address = this.$props.serviceRequest.patient.address;
                this.$props.serviceRequest.appointments[0].timezone = address.timezone;
                this.setSelectedTimezone(address.timezone);
                this.copyPickupAddresses();
                this.copyDropoffAddresses();
            }
        }
    }

    private async onFacilityLatLngChanged() {
        const facilityAddress = this.$props.serviceRequest.facility.address;
        if (facilityAddress.latitude && facilityAddress.longitude) {
            this.$props.serviceRequest.facility.address =
                await MapUtils.getAddressByCoordinates(facilityAddress.latitude, facilityAddress.longitude);
            if (this.$props.serviceRequest.service.selectedType !== 'Delivery') {
                const address = this.$props.serviceRequest.facility.address;
                this.$props.serviceRequest.appointments[0].timezone = address.timezone;
                this.setSelectedTimezone(address.timezone);
                this.copyPickupAddresses();
                this.copyDropoffAddresses();
            }
        }
    }

    private next() {
        if (this.$v.$invalid) {
            this.$data.showRequiredFieldMessage = true;
        } else {
            this.$props.serviceRequest.stops.isStop3Valid = true;
            if (this.locations) {
               if (this.$data.isLienCustomerEnabled) {
                    const primaryLocation = this.locations.find((loc) => loc.isPrimaryLocation === true);
                    if (primaryLocation) {
                        this.$props.serviceRequest.billingLocation = primaryLocation;
                        this.$props.serviceRequest.billingLocationId = primaryLocation.id;
                    }
                } else {
                    this.locations.forEach((location) => {
                        if (location.id === this.$props.serviceRequest.billingLocationId) {
                            this.$props.serviceRequest.billingLocation = location;
                            return;
                        }
                    });
                }
            }
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_CONFIRMATION });
        }
    }
    private async getHealthcareProviders() {
        const response = await ObjectFactory.getProviderService()
            .getHealthcareProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.healthcareProviders = response.data as any;
    }
    private async getPatientList(searchString?: string, start?: number) {
        const locations: string[] = [];
        if (this.memberProfile.memberType === 'ORG_MANAGER' && this.memberProfile.managedLocations) {
            this.memberProfile.managedLocations.forEach((location) => {
                locations.push(location.name);
            });
        }
        const response = await ObjectFactory.getPatientService()
            .getPatientList(this.$store.state.serverUrl, '', 0, 1000, locations);
        this.$data.patientOptions = response.data as any;
    }
    private addEmail() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (this.healthcareProviders) {
            if (serviceRequest.service.type === 'Interpretation') {
                const objIndex = this.healthcareProviders.findIndex(((obj) =>
                    obj.fullname === this.$props.serviceRequest.facility.name));
                serviceRequest.facility.email = this.healthcareProviders[objIndex].email;
            }
        }
    }
    private addAppointmentDateTime() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments.length < 20) {
            serviceRequest.appointments.push({
                date: '',
                time: '',
                timezone: DateUtils.getLocalTimezone(),
                returnPickupTime: '',
            });
        }
    }
    private removeAppointmentDateTime(index: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments.length > 1) {
            serviceRequest.appointments.splice(index, 1);
        }
    }
    private onMultipleAppointment() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.multipleAppointment = !serviceRequest.multipleAppointment;
        serviceRequest.appointments = [{
            date: '',
            time: '',
            timezone: DateUtils.getLocalTimezone(),
            returnPickupTime: '',
        }];
    }
    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

    private  addContact() {
        this.showAdditionalContacts = true;
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.additionalContacts.push({
            isSMS: false,
            isEmail: false,
            phone: '',
            email: '',
            contactName: '',
            relationshipToPatient: '',
        });
    }

    private  deleteContact(index: any) {
        this.$props.serviceRequest.additionalContacts.splice(index, 1);
    }

    private async onPatientSelect(selectedOption: Patient) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.patient.fullName = selectedOption.fullName;
        serviceRequest.patient.email = selectedOption.email;
        serviceRequest.patient.phone = selectedOption.phone;
        this.updateBirthdate(selectedOption.birthdate);
        serviceRequest.patient.caseNumber = selectedOption.caseNumber ? selectedOption.caseNumber : '';
        const fullName = serviceRequest.patient.fullName;
        if (fullName !== undefined) {
            const space = fullName.indexOf(' ');
            serviceRequest.patient.firstName = fullName.substring(0, space);
            serviceRequest.patient.lastName = fullName.substring(space + 1);
        }
        if (selectedOption.address && (!selectedOption.address.latitude || !selectedOption.address.longitude)) {
            try {
                serviceRequest.patient.address = await MapUtils.getAddressByStreet(selectedOption.address.fullAddress);
            } catch (error) {
                serviceRequest.patient.address = {
                    fullAddress: '',
                    city: '',
                    locality: '',
                    subLocality: '',
                    state: '',
                    zip: '',
                    country: '',
                    landmark: '',
                    latitude: '' as any,
                    longitude: '' as any,
                    timezone: '',
                };
            }
        } else {
            serviceRequest.patient.address = selectedOption.address;
        }
    }

    private setPatientFullName() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.patient.firstName && serviceRequest.patient.lastName) {
            serviceRequest.patient.fullName = serviceRequest.patient.firstName + ' ' + serviceRequest.patient.lastName;
        }
    }

    private onRxStopChecked(event: boolean) {
        if (event) {
            this.rxStopGoogleAddress = new google.maps.places.Autocomplete
                (this.$refs.rxStopAddress, { types: ['geocode'] });
            this.rxStopGoogleAddress.addListener('place_changed', async () => {
                this.$props.serviceRequest.transportation.rxStop.rxAddress =
                    MapUtils.parseGoogleAddress(this.rxStopGoogleAddress);
            });
        }
    }

    private async uploadImage(type: string) {
        const fileInput = type === 'pickup' ? this.$refs.pickupInput as HTMLInputElement
            : this.$refs.dropoffInput as HTMLInputElement;
        this.$data.pickupInstructionImageUploading = type === 'pickup' ? true : false;
        this.$data.dropoffInstructionImageUploading = type === 'dropoff' ? true : false;
        if (type === 'pickup' && (this.$props.serviceRequest.pickupSameAsPatientAddress ||
                (!this.$props.serviceRequest.pickupSameAsPatientAddress &&
                    !this.$props.serviceRequest.pickupSameAsBussinessAddress))) {
            this.$data.pickupImgUploadedByCustomer = true;
        }
        if (type === 'dropoff' && (this.$props.serviceRequest.dropoffSameAsPatientAddress ||
                (!this.$props.serviceRequest.dropoffSameAsPatientAddress &&
                    !this.$props.serviceRequest.dropoffSameAsBussinessAddress))) {
            this.$data.dropoffImgUploadedByCustomer = true;
        }
        if (fileInput && fileInput.files) {
            const file = fileInput.files[0];
            if (file) {
                const allowedExtensions = ['.jpg', '.jpeg', '.png'];
                const fileExtension = file.name.slice(Math.max(file.name.lastIndexOf('.') - 1, 0) + 2);
                if (allowedExtensions.includes('.' + fileExtension.toLowerCase())) {
                    const formData = new FormData();
                    formData.append('file', file);
                    try {
                        const iHttpService = ObjectFactory.getHttpService();
                        const apiRequest: ApiRequest = {
                            baseURL: this.$store.state.serverUrl,
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
                            data: formData,
                        };

                        const response = await iHttpService.post < UploadFileResponse > (apiRequest);
                        if (response.success && response.data) {
                            if (type === 'pickup') {
                                this.$props.serviceRequest.pickupAddress.pickupInstructionImageResourceId
                                    = response.data.fileName;
                            }
                            if (type === 'dropoff') {
                                this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageResourceId
                                    = response.data.fileName;
                            }
                            const toastEvent: ToastEvent = {
                                message: 'Image Uploaded Successfully',
                                title: 'Success',
                                varient: 'success',
                                timeout: 5000,
                            };
                            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                        }
                    } catch (error) {
                        const toastEvent: ToastEvent = {
                            message: 'Error while uploading Image',
                            title: 'Error',
                            varient: 'danger',
                            timeout: 5000,
                        };
                        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                    }
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        if (e.target && e.target.result) {
                            if (type === 'pickup') {
                                this.$data.pickupInstructionImageUploading = false;
                                this.$data.pickupAddress.pickupInstructionImageUrl = e.target.result as string;
                                this.$props.serviceRequest.pickupAddress.pickupInstructionImageUrl =
                                    e.target.result as string;
                            } else if (type === 'dropoff') {
                                this.$data.dropoffInstructionImageUploading = false;
                                this.$data.dropoffAddress.dropoffInstructionImageUrl = e.target.result as string;
                                this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageUrl =
                                    e.target.result as string;
                            }
                        }
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.$data.pickupInstructionImageUploading = false;
                    this.$data.dropoffInstructionImageUploading = false;
                    const toastEvent: ToastEvent = {
                        message: 'Enter Valid Picture',
                        title: 'Error',
                        varient: 'danger',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                }
            }
        }
    }

    private async removeImage(type: string) {
        let resourceId = '';
        let isFacilityImage = false;
        if (type === 'pickup') {
            resourceId = this.$props.serviceRequest.pickupAddress.pickupInstructionImageResourceId;
        }
        if (type === 'dropoff') {
            resourceId = this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageResourceId;
        }
        if (type === 'pickup' && (this.$props.serviceRequest.pickupSameAsPatientAddress ||
                (!this.$props.serviceRequest.pickupSameAsPatientAddress &&
                    !this.$props.serviceRequest.pickupSameAsBussinessAddress))) {
            this.$data.pickupImgUploadedByCustomer = false;
        }
        if (type === 'dropoff' && (this.$props.serviceRequest.dropoffSameAsPatientAddress ||
                (!this.$props.serviceRequest.dropoffSameAsPatientAddress &&
                    !this.$props.serviceRequest.dropoffSameAsBussinessAddress))) {
            this.$data.dropoffImgUploadedByCustomer = false;
        }
        const healthcareProvider = this.healthcareProviders.find((element) => {
            return element.fullname === this.$props.serviceRequest.facility.name;
        });
        if (healthcareProvider &&
            (healthcareProvider.pickupInstructionImageResourceId === resourceId ||
                healthcareProvider.dropoffInstructionImageResourceId === resourceId) ) {
            isFacilityImage = true;
        }
        if (!isFacilityImage) {
                const response = await ObjectFactory.getFileService().
                deleteFile(resourceId, this.$store.state.serverUrl);
                if (response.success) {
                    const toastEvent: ToastEvent = {
                        message: 'Image Removed Successfully',
                        title: 'Success',
                        varient: 'success',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                } else {
                    const toastEvent: ToastEvent = {
                        message: 'Error While Deleting Image.',
                        title: 'Error',
                        varient: 'danger',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                }
        }
        if (type === 'pickup') {
            this.$props.serviceRequest.pickupAddress.pickupInstructionImageResourceId = '';
            this.$props.serviceRequest.pickupAddress.pickupInstructionImageUrl = '';
            this.$data.pickupAddress.pickupInstructionImageUrl = '';
        }
        if (type === 'dropoff') {
            this.$props.serviceRequest.dropoffAddress.dropoffInstructionImageResourceId = '';
            this.$props.serviceRequest.pickupAddress.dropoffInstructionImageUrl = '';
            this.$data.dropoffAddress.dropoffInstructionImageUrl = '';
        }
    }

    private async getResource(resourceId: string): Promise<any> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${resourceId}`,
        };
        const response = await iHttpService.get < any > (apiRequest);
        if (response.success && response.data) {
            return response.data;
        }
    }

    private async getRxProviderList() {
        const response = await ObjectFactory.getRxProviderService()
            .getRxProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.rxProviders = response.data as any;
        this.$data.rxProvidersOptions = [];
        this.rxProviders.forEach((rxProvider: RxProvider) => {
            if (rxProvider.status === 'ACTIVE') {
                const providersOption = {
                    value: rxProvider.fullname,
                    text: rxProvider.fullname,
                };
                this.$data.rxProvidersOptions.push(providersOption);
            }
        });
    }

    private copyRxProvider(fullname: string) {
        if (this.rxProviders) {
            this.rxProviders.forEach((rxProvider) => {
                if (rxProvider.fullname === fullname) {
                    if (rxProvider.address) {
                        this.$props.serviceRequest.transportation.rxStop.rxAddress = rxProvider.address;
                    } else {
                        this.$props.serviceRequest.transportation.rxStop.rxAddress = {
                            city: '',
                            fullAddress: '',
                            state: '',
                            zip: '',
                        };
                    }
                    this.$props.serviceRequest.transportation.rxStop.businessCloseTime = rxProvider.businessCloseTime ?
                    rxProvider.businessCloseTime : '';
                    this.$props.serviceRequest.transportation.rxStop.email = rxProvider.email ? rxProvider.email : '';
                    if (rxProvider.phone) {
                        this.$props.serviceRequest.transportation.rxStop.phone = rxProvider.phone.trim();
                    }
                }
            });
        }
    }

    private onSmsEmailSelected(index: number) {
        const additionalContact = this.$props.serviceRequest.additionalContacts[index];
        if (!additionalContact.isSMS) {
            additionalContact.phone = '';
        }

        if (!additionalContact.isEmail) {
            additionalContact.email = '';
        }
    }

    private setSelectedTimezone(timezone: string) {
        if (timezone) {
            this.TimeZones.forEach((continent: any) => {
                continent.timezones.forEach((timezoneObj: any) => {
                    if (timezoneObj.value === timezone) {
                        this.selectedTimezone = timezoneObj;
                    }
                });
            });
        }
    }

    private setTimezone(timezone: any) {
        this.$props.serviceRequest.appointments[0].timezone = timezone.value;
    }

    private async onAttorneySelect(selectedOption: Attorney) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest && serviceRequest.transportation) {
            serviceRequest.transportation.attorneyName = selectedOption.name;
            serviceRequest.transportation.attorneyEmail = selectedOption.email;
            serviceRequest.transportation.attorneyPhoneNo = selectedOption.phoneNo;
            serviceRequest.transportation.attorneyFirmName = selectedOption.firmName;
        }
    }

    private async getAttorneyList() {
        try {
            const iHttpService = ObjectFactory.getHttpService();
            const userIds: string[] = [this.memberProfile.memberId];
            if (this.memberProfile.parentMemberId) {
                userIds.push(this.memberProfile.parentMemberId);
            }
            const queryRecordsRequest: any = {
                conditions: [
                    {
                        op: 'eq',
                        fieldName: 'organizationId',
                        value: this.memberProfile &&
                                this.memberProfile.organization ?
                                this.memberProfile.organization.id : '',
                    },
                    {
                        op: 'eq',
                        fieldName: 'status',
                        value: 'ACTIVE',
                    },
                    {
                        op: 'in',
                        fieldName: 'memberId',
                        value: userIds,
                    },
                ],
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                data: queryRecordsRequest,
                url: `${MedTransGoConstants.HTTP_URL_ATTORNEY}/list`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<any[]>(apiRequest);
            if (response.success && response.data) {
                this.$data.attorneyOptions = response.data;
            }
        } catch (error) {
            console.error('Error fetching attorney list:', error);
        }
    }

    private updateBirthdate(newDate: any) {
      this.$set(this.$props.serviceRequest.patient, 'birthdate', newDate);

      if (this.$v.serviceRequest.patient && this.$v.serviceRequest.patient.birthdate) {
        this.$v.serviceRequest.patient.birthdate.$touch();
        this.$v.serviceRequest.$reset();
      }
    }
    private isNumber(evt: KeyboardEvent) {
        const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const keyPressed: string = evt.key;
        if (!keysAllowed.includes(keyPressed)) {
            evt.preventDefault();
        }
    }

    private async checkMileage() {
        this.$props.serviceRequest.hasUserDeclinedMileage = false;
        this.isNextDisabled = false;
        if (this.locations) {
            this.locations.forEach((location) => {
                if (location.id === this.$props.serviceRequest.billingLocationId) {
                    this.$props.serviceRequest.billingLocation = location;
                    return;
                }
            });
            if (this.$props.serviceRequest.billingLocation &&
                (this.$props.serviceRequest.billingLocation.ruralMileageLimit ||
                this.$props.serviceRequest.billingLocation.nonRuralMileageLimit)) {
                const mileageLimitRequest: MileageLimitRequest = {
                    billingLocationId: this.$props.serviceRequest.billingLocationId,
                    organizationId: this.memberProfile.organization ? this.memberProfile.organization.id : '',
                    pickupAddress: this.$props.serviceRequest.pickupAddress,
                    dropoffAddress: this.$props.serviceRequest.dropoffAddress,
                };
                const iHttpService = ObjectFactory.getHttpService();
                const apiRequest: ApiRequest = {
                    baseURL: this.$store.state.serverUrl,
                    url: `${MedTransGoConstants.HTTP_URL_REQUEST}/checkMileageLimit`,
                    data: mileageLimitRequest,
                };
                const response = await iHttpService.post<any>(apiRequest);
                if (response.data && response.success) {
                    this.mileageLimit = response.data;
                    this.$props.serviceRequest.isMileageExceeded = this.mileageLimit.isMileageExceeded;
                }
            }
        }
    }

    private handleMileageProceed() {
        this.isNextDisabled = false;
        this.$props.serviceRequest.hasUserDeclinedMileage = false;
        this.mileageLimit.isMileageExceeded = false;
    }

    private handleMileageDecline() {
        this.isNextDisabled = true;
        this.$props.serviceRequest.hasUserDeclinedMileage = true;
        this.mileageLimit.isMileageExceeded = false;
    }

}
